if (!customElements.get("cart-quantity")) {
  class CartQuantity extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleChangeRef = this.handleChange.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      if (!event.target.hasAttribute("data-action")) return;

      this.updateQuantityViaLine(Number(this.querySelector("input").value) + 1 * event.target.getAttribute("data-action"));
    }

    handleChange(event) {
      if (event.target.value.length === 0 && !isNaN(+event.target.value)) return;

      this.updateQuantityViaLine(+event.target.value);
    }

    async getCurrentCartItems() {
      const response = await fetch('/cart.js', { method: "GET" });
      const cartJSON = await response.json();

      return cartJSON.items;
    }

    async updateQuantityViaLine(quantity) {
      /* Fix for item keys not working:
        Shopify API is currently disregarding item keys and only using the variant ID portion of the key
        This impacts updating items that may have the same variant ID, like bundle items
        In order to update bundle items correctly, we are using the array of numbers send to update.js
        This requires sending an array of quantities for every item in the cart
      */
      const cartItems = await this.getCurrentCartItems();

      const updates = cartItems.map((item) => item.quantity);
      const cartKeyMap = cartItems.map((item) => item.key);
      const cartVariantMap = cartItems.map((item) => item.variant_id);
      const itemKeys = this.getAttribute("data-keys").split(',');

      const feeVariantIds = new Set();
      (window.coolers || []).forEach(c => feeVariantIds.add(String(c.variant_id)));
      if (window.warmWeather?.variantId) feeVariantIds.add(String(window.warmWeather.variantId));

      itemKeys.forEach(key => {
        const keyIndex = cartKeyMap.indexOf(key);
        if (keyIndex > -1) {
          updates[keyIndex] = quantity;
        }
      });

      const calcTriggeringQty = () => {
        let total = 0;
        cartItems.forEach(item => {
          if (feeVariantIds.has(String(item.variant_id))) return;
          if (item.properties?._isWarmWeatherShippingProduct) return;
          total += itemKeys.includes(item.key) ? quantity : item.quantity;
        });
        return total;
      };

      const hasOtherNonFeeItems = () => {
        return cartItems.some(item =>
          !feeVariantIds.has(String(item.variant_id)) &&
          !item.properties?._isWarmWeatherShippingProduct &&
          !itemKeys.includes(item.key)
        );
      };

      if (this.hasAttribute("data-coolers")) {
        const coolers = this.dataset.coolers.split(',');
        const coolerConfigs = window.coolers || [];

        coolers.forEach(coolerVariantId => {
          const config = coolerConfigs.find(c => String(c.variant_id) === String(coolerVariantId));
          const mode = config?.mode || 'per_triggering_item';
          const keyIndex = cartVariantMap.indexOf(coolerVariantId);

          if (keyIndex === -1) return;

          if (mode === 'per_triggering_item') {
            updates[keyIndex] = calcTriggeringQty();
          } else if (quantity === 0 && !hasOtherNonFeeItems()) {
            updates[keyIndex] = 0;
          }
        });
      }

      if (this.hasAttribute("data-warm-weather-variant")) {
        const variantId = this.getAttribute("data-warm-weather-variant");
        const wwMode = this.getAttribute("data-warm-weather-mode") || "per_order";
        const keyIndex = cartVariantMap.indexOf(variantId);

        if (keyIndex > -1) {
          if (wwMode === 'per_triggering_item') {
            updates[keyIndex] = calcTriggeringQty();
          } else if (quantity === 0 && !hasOtherNonFeeItems()) {
            updates[keyIndex] = 0;
          }
        }
      }

      // Standard update.js POST, same as in updateQuantity
      const body = JSON.stringify({
        updates,
        sections: `${this.getAttribute("data-section-id")}`,
      });

      fetch(window.routes.cart_update_url, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((responseText) => {
          dispatchCartEvent(
            JSON.parse(responseText).sections,
            this.getAttribute("data-section-id")
          );
        })
        .catch((error) => console.log(error));
    }

    updateQuantity(quantity) {
      const updates = {};
      const keys = this.getAttribute("data-keys").split(',');

      keys.forEach(key => {
        updates[key] = quantity;
      });

      if (this.hasAttribute("data-coolers")) {
        const coolers = this.dataset.coolers.split(',');
        const coolerConfigs = window.coolers || [];

        coolers.forEach(coolerVariantId => {
          const config = coolerConfigs.find(c => String(c.variant_id) === String(coolerVariantId));
          const mode = config?.mode || 'per_triggering_item';

          if (mode === 'per_triggering_item') {
            updates[coolerVariantId] = quantity;
          } else if (quantity === 0) {
            updates[coolerVariantId] = 0;
          }
        });
      }

      if (this.hasAttribute("data-warm-weather-variant")) {
        const wwMode = this.getAttribute("data-warm-weather-mode") || "per_order";

        if (wwMode === 'per_triggering_item') {
          updates[`${this.getAttribute("data-warm-weather-variant")}`] = quantity;
        } else if (quantity === 0) {
          updates[`${this.getAttribute("data-warm-weather-variant")}`] = 0;
        }
      }

      const body = JSON.stringify({
        updates,
        sections: `${this.getAttribute("data-section-id")}`,
      });

      fetch(window.routes.cart_update_url, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((responseText) => {
          dispatchCartEvent(
            JSON.parse(responseText).sections,
            this.getAttribute("data-section-id")
          );
        })
        .catch((error) => console.log(error));
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClickRef);
      this.removeEventListener("change", this.handleChangeRef);
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClickRef);
      this.addEventListener("change", this.handleChangeRef);
    }
  }

  customElements.define("cart-quantity", CartQuantity);
}
